import { normilizeMovieInputValue, normilizeMovieReturnValue, moderationInfoInputValue } from "./utils";

export const getById = async (supabase, id) => {
  const result = await supabase
  .from('movies')
  .select()
  .eq('id', id);
  (result.error || !result?.data) && console.error('getById movies method: ', result.error);
  return normilizeMovieReturnValue(result.data) || [];
}

export const getByIds = async (supabase, ids) => {
  try {
    const result = await supabase
      .from('movies')
      .select()
      .in('id', ids);
    return normilizeMovieReturnValue(result.data) || [];
  } catch (error) {
    console.error('getByIds movies method: ', error);
  }
}

export const checkId = async (supabase, id) => {
  try {
    const result = await supabase
      .from('movies')
      .select('id')
      .eq('id', id);
    return normilizeMovieReturnValue(result?.data);
  } catch (error) {
    console.error('checkId movies method: ', error);
  }
}

export const checkIds = async (supabase, ids) => {
  const result = await supabase
  .from('movies')
  .select()
  .in('id', ids);
  result.error && console.error('chekcId movies method: ', result.error);
  return normilizeMovieReturnValue(result?.data);
}

export const put = async (supabase, data) => {
  try {
    const result = await supabase
    .from('movies')
    .upsert(normilizeMovieInputValue(data), { onConflict: ['id'] });
    return result?.data;
  } catch (error) {
    console.error('chekcId movies method: ', error)
  } 
}

export const updateById = async (supabase, id, data) => {
  try {
    data && (await supabase
  .from('movies')
  .update(normilizeMovieInputValue([data])[0])
  .eq('id', id))
  } catch (error) {
    console.error('updateById movies method: ', error);
  }
}

// When setting non-null moderation_info, INSERT a minimal row if the movies
// record doesn't exist — otherwise .update() silently no-ops against missing
// IDs and the exclusion never persists. (Seen with Road to Everywhere at
// Village East: 7 showtimes referenced movie_id=189117 with no movies row,
// so every "Exclude" click did nothing.) Clearing (null) keeps update-only
// behavior since there's nothing to persist when no row exists anyway.
export const updateModerationInfo = async (supabase, id, moderatedInfo, fallbackTitle = null) => {
  try {
    if (moderatedInfo && fallbackTitle) {
      const { data: existing } = await supabase
        .from('movies')
        .select('id')
        .eq('id', id)
        .maybeSingle();
      if (existing) {
        await supabase
          .from('movies')
          .update({ moderation_info: moderatedInfo })
          .eq('id', id);
      } else {
        await supabase
          .from('movies')
          .insert([{
            id,
            title: fallbackTitle,
            slug: `excluded-${id}`,
            moderation_info: moderatedInfo,
          }]);
      }
    } else {
      await supabase
        .from('movies')
        .update({ moderation_info: moderatedInfo || null })
        .eq('id', id);
    }
    return { code: 200, status: 'OK' };
  } catch (error) {
    console.error('updateModerationInfo: ', error);
    return { code: 500, status: error?.message || 'unknown' };
  }
}

export const updateVerifiedAt = async (supabase, id, verifiedAt) => {
  try {
    await supabase
      .from('movies')
      .update({ verified_at: verifiedAt })
      .eq('id', id)
    return { code: 200, status: 'OK' };
  } catch (error) {
    console.error('updateVerifiedAt movies method: ', error);
  }
}

export const deleteById = async (supabase, id) => {
  const result = await supabase
    .from('movies')
    .delete()
    .eq('id', id);
  result.error && console.error('deleteById movies method: ', result.error);
}

export const getBySlug = async (supabase, slug) => {
  const result = await supabase
    .from('movies')
    .select()
    .eq('slug', slug)
    .maybeSingle();
  if (result.error) throw result.error;
  if (!result.data) return null;
  return normilizeMovieReturnValue([result.data])[0];
}

export const deleteAll = async (supabase) => {
  const result = await supabase
    .from('movies')
    .delete()
    .neq('id', null)
  result.error && console.error('deleteByIds movies method: ', result.error);
}